export default "__VITE_ASSET__rIqBng0X__"